const sameVariant = (left, right) =>
  left[0] === right[0] && left[1] === right[1];

function getWeightSearchOrder(weights, requestedWeight) {
  const sorted = Array.from(new Set(weights)).sort((a, b) => a - b);
  if (sorted.includes(requestedWeight)) {
    return [requestedWeight];
  }

  if (requestedWeight >= 400 && requestedWeight <= 500) {
    return [
      ...sorted.filter((weight) => weight >= requestedWeight && weight <= 500),
      ...sorted.filter((weight) => weight < requestedWeight).reverse(),
      ...sorted.filter((weight) => weight > 500),
    ];
  }
  if (requestedWeight < 400) {
    return [
      ...sorted.filter((weight) => weight < requestedWeight).reverse(),
      ...sorted.filter((weight) => weight > requestedWeight),
    ];
  }
  return [
    ...sorted.filter((weight) => weight > requestedWeight),
    ...sorted.filter((weight) => weight < requestedWeight).reverse(),
  ];
}

/** Selects the deterministic CSS Fonts weight fallback for the preferred style. */
export default function selectFontVariant(available, requested) {
  if (
    !available.length ||
    available.some((variant) => sameVariant(variant, requested))
  ) {
    return requested;
  }

  const sameStyle = available.filter((variant) => variant[0] === requested[0]);
  const candidates = sameStyle.length ? sameStyle : available;
  const [selectedWeight] = getWeightSearchOrder(
    candidates.map((variant) => variant[1]),
    requested[1]
  );
  return (
    candidates
      .filter((variant) => variant[1] === selectedWeight)
      .sort((a, b) => a[0] - b[0])[0] || requested
  );
}
